/**
 * The timeline table's column recipe (spine · Time · # · List · Notes ·
 * Gateway · Senders · Texts · Amount · $ / SMS · Est.$ — the List column
 * 19/10/2026, Senders and Texts 22/10/2026, the route's price 23/10/2026)
 * shared by header and rows, plus band tinting.
 * For Media Devoted | Created By Ciro Autiero
 */
export const TIMELINE_GRID =
  'grid grid-cols-[4px_120px_32px_minmax(200px,1.3fr)_minmax(130px,1fr)_minmax(110px,170px)_minmax(100px,150px)_minmax(160px,1.4fr)_72px_64px_64px] items-center gap-3 pr-4';

/** ~7% alpha of the container color for the band background. */
export const bandTint = (hex: string) => `${hex}12`;

/** 35% alpha spine on item rows, full on the band. */
export const spineColor = (hex: string, faded: boolean) =>
  faded ? `${hex}59` : hex;
